import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper3 = new Swiper(".section3 .swiper", {
    slidesPerView: 3.75,
    spaceBetween: 20,
    loop:true,
    speed:5000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    breakpoints: {
        1024: {  //当屏幕宽度小于等于1280
            slidesPerView: 3.75,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }, 
});